import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@tectonics/utils/utils';

const alertVariants = cva(
  'group/alert relative grid w-full gap-2 rounded-md p-3 text-left text-xs has-data-[slot=alert-action]:relative has-data-[slot=alert-action]:pr-18 has-[>svg]:grid-cols-[auto_1fr] has-[>svg]:gap-x-2 *:[svg]:row-span-2 *:[svg]:translate-y-0.5 *:[svg]:text-current *:[svg:not([class*=\'size-\'])]:size-4',
  {
    variants: {
      variant: {
        default: 'bg-alert-bg text-card-foreground',
        destructive:
          'bg-card text-destructive *:data-[slot=alert-description]:text-destructive/90 *:[svg]:text-current',
      },
      lookAndFeel: {
        default: '',
        volcanes: '',
        shopify: 'rounded-[3px] bg-[var(--color-alert-warning-bg)] p-[12px] text-[12px] text-current',
      },
    },
    defaultVariants: {
      variant: 'default',
      lookAndFeel: 'default',
    },
  }
);
function Alert({
  className,
  variant,
  lookAndFeel = 'default',
  ...props
}: React.ComponentProps<'div'> & VariantProps<typeof alertVariants>) {
  return (
    <div
      data-slot="alert"
      role="alert"
      className={cn(alertVariants({ variant, lookAndFeel }), className)}
      {...props}
      data-look-and-feel={lookAndFeel}
    />
  );
}
function AlertTitle({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="alert-title"
      className={cn(
        'font-medium group-has-[>svg]/alert:col-start-2 [&_a]:underline [&_a]:underline-offset-3 [&_a]:hover:text-foreground',
        className
      )}
      {...props}
    />
  );
}
function AlertDescription({
  className,
  ...props
}: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="alert-description"
      className={cn(
        'text-sm text-balance text-[#081F2B] md:text-pretty [&_a]:underline [&_a]:underline-offset-3 [&_a]:hover:text-foreground [&_p:not(:last-child)]:mb-4',
        className
      )}
      {...props}
    />
  );
}
function AlertAction({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="alert-action"
      className={cn('absolute top-3 right-3', className)}
      {...props}
    />
  );
}
export { Alert, AlertTitle, AlertDescription, AlertAction };
